<template>
	<section
		class="hero hero--property h-auto xl:h-screen w-full relative overflow-hidden will-change"
		data-scroll-section
	>
		<!-- hero img -->
		<div class="hero__img-wraper h-screen relative xl:absolute">
			<img
				class="hero__img"
				v-show="fieldsData.image"
				:src="fieldsData.image.url"
				:alt="fieldsData.image.alt"
			/>

			<!-- ./hero img / video -->

			<div
				class="hero__content flex flex-col px-content absolute top-0 left-0 w-full h-full z-[18]"
			>
				<div class="uppercase my-auto text-white">
					<p :class="breadcrumbClasses" v-if="fieldsData.resale">
						<a class="breadcrumbs-link" :href="homeUrl">{{
							breadcrumbData[language]?.homepage
								? breadcrumbData[language]?.homepage
								: "Home"
						}}</a
						><span> > </span
						><a
							class="breadcrumbs-link"
							:href="breadcrumbData[language].parentLink"
							>{{ breadcrumbData[language].parentTitle }}</a
						><span> > </span><span>{{ postData.post_title }}</span>
					</p>
					<p
						class="text-center xl:text-left mb-7 leading-5 tracking-desk"
						v-show="postData.post_title"
					>
						{{ postData.post_title }}
					</p>
					<h1
						class="text-center xl:text-left text-4xl xl:text-[64px] leading-none text-white font-normal"
						v-show="postData.neighbourhood_category"
						v-html="postData.neighbourhood_category[0].name"
					></h1>
				</div>
			</div>
		</div>
		<!-- ./hero content -->

		<!-- hero bottom info -->
		<div
			class="hero__btm-info flex flex-col xl:flex-row xl:items-center justify-between bg-navy-blue-01 px-content py-9 relative xl:absolute bottom-0 left-0 w-full z-20"
		>
			<div class="flex flex-col mb-8 xl:mb-0" v-show="postData.property_type">
				<span class="text-small tracking-little text-navy-blue-03">{{
					__("TYPE", "ccave")
				}}</span>
				<h5 class="text-white text-xl font-light tracking-[1px] mt-[10px]">
					{{ postData.property_type[0].name }}
				</h5>
			</div>
			<div class="flex flex-col mb-8 xl:mb-0" v-show="fieldsData.price">
				<span class="text-small tracking-little text-navy-blue-03">{{
					__("PRICE STARTING AT", "ccave")
				}}</span>
				<h5 class="text-white text-xl font-light tracking-[1px] mt-[10px]">
					€ {{ fieldsData.price }}
				</h5>
			</div>
			<div class="flex flex-col mb-8 xl:mb-0" v-show="fieldsData.size">
				<span class="text-small tracking-little text-navy-blue-03">{{
					__("SIZE", "ccave")
				}}</span>
				<h5 class="text-white text-xl font-light tracking-[1px] mt-[10px]">
					{{ fieldsData.size }} m²
				</h5>
			</div>
			<div
				class="flex flex-col mb-8 xl:mb-0"
				v-show="fieldsData.number_of_bedrooms"
			>
				<span class="text-small tracking-little text-navy-blue-03">{{
					__("NUMBER OF BEDROOMS", "ccave")
				}}</span>
				<h5 class="text-white text-xl font-light tracking-[1px] mt-[10px]">
					{{ getBedroomsLabelForSingleProperty(fieldsData.number_of_bedrooms) }}
				</h5>
			</div>
			<div class="flex flex-col mb-8 xl:mb-0" v-show="fieldsData.status">
				<span class="text-small tracking-little text-navy-blue-03">{{
					__("STATUS", "ccave")
				}}</span>
				<h5 class="text-white text-xl font-light tracking-[1px] mt-[10px]">
					{{ fieldsData.status }}
				</h5>
			</div>
			<a class="btn btn-clean mt-0" href="#formBlock">{{
				__("REGISTER INTEREST", "ccave")
			}}</a>
		</div>
		<!-- ./hero bottom info -->
	</section>
</template>

<script>
export default {
	name: "HeroProperty",
	data() {
		return {
			homeUrl: "",
			language: document.documentElement.lang || "en",
			breadcrumbData: {
				en: {
					parentLink: "/resale-units-lb/",
					parentTitle: "Resale Units",
				},
				"ru-RU": {
					homepage: "Главная",
					parentLink: "/ru/resale-units-lb/",
					parentTitle: "Resale Units",
				},
			},
		};
	},
	computed: {
		breadcrumbClasses() {
			return [
				"breadcrumbs mb-4 xl:mb-9",
				this.isToponymPage ? "xl:text-left" : "text-center xl:text-left",
			];
		},
	},
	mounted() {
		if (document.documentElement.lang.split("-")[0] === "en") {
			this.homeUrl = window.location.origin;
		} else if (document.documentElement.lang.split("-")[0] === "sr") {
			this.homeUrl = `${window.location.origin}/me`;
		} else {
			this.homeUrl = `${window.location.origin}/${
				document.documentElement.lang.split("-")[0]
			}`;
		}
	},
	methods: {
		getBedroomsLabelForSingleProperty(number) {
			number = parseInt(number);
			if (number === -1) {
				return this.__("Studio", "ccave");
			} else if (number === 1) {
				return number + " " + this.__("bedroom", "ccave");
			} else if (number > 1) {
				return number + " " + this.__("Bedrooms", "ccave");
			}
		},
	},
};
</script>
